import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/runner/work/vibranium/vibranium/src/components/Layout.jsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "configure-vibranium",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h1" {...{
        "href": "#configure-vibranium",
        "aria-label": "configure vibranium permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Configure Vibranium`}</h1>
    <p>{`This step initializes Vibranium configurations. Open Command Line/ Terminal and change the directory to the directory that you with to make as your workspace and run the following command and enter the answers to the questions that follow`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`vc setup
`}</code></pre>
    <blockquote>
      <p parentName="blockquote">{`Make sure you navigate to the workspace directory before running this command as it sets the current working directory as the workspace.`}</p>
    </blockquote>
    <h3 {...{
      "id": "example",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h3" {...{
        "href": "#example",
        "aria-label": "example permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Example:`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`cd ˜  
mkdir workspace
cd  workspace

vc setup
                                         
Please enter your user id: sarathm09
Please enter your email id: some.email@domain.com
Please enter your name: VibraniumTester
`}</code></pre>
    <p>{`This step basically register the current working directory as the workspace in the internal Vibranium configuration, and creates the initial set of directories like `}<inlineCode parentName="p">{`jobs`}</inlineCode>{` and `}<inlineCode parentName="p">{`logs`}</inlineCode>{`. `}</p>
    <h2 {...{
      "id": "clone-test-cases",
      "style": {
        "position": "relative"
      }
    }}><a parentName="h2" {...{
        "href": "#clone-test-cases",
        "aria-label": "clone test cases permalink",
        "className": "anchor before"
      }}><svg parentName="a" {...{
          "aria-hidden": "true",
          "focusable": "false",
          "height": "16",
          "version": "1.1",
          "viewBox": "0 0 16 16",
          "width": "16"
        }}><path parentName="svg" {...{
            "fillRule": "evenodd",
            "d": "M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z"
          }}></path></svg></a>{`Clone test cases`}</h2>
    <p>{`If you have test cases already available, you'll have to clone the test cases into the workspace`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`cd ˜/workspace
git clone https://github.com/someUserOrOrg/Vibranium-Tests.git
`}</code></pre>
    <p><a parentName="p" {...{
        "href": "1.3.installation.md"
      }}>{`Previous`}</a>{`
`}<a parentName="p" {...{
        "href": "1.5.config_json.md"
      }}>{`Next`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      